document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll('.Accordions__single');

    accordions.forEach(accordion => {
        const heading = accordion.querySelector('.heading');
        const content = accordion.querySelector('.content');

        if (accordion.classList.contains('firstOpen')) {
            accordion.classList.add('active');
        }

        content.style.transition = "max-height 0.3s ease-out";
        content.style.overflow = "hidden";
        content.style.maxHeight = accordion.classList.contains('active') ? content.scrollHeight + "px" : "0";

        heading.addEventListener('click', function() {
            const isActive = accordion.classList.contains('active');

            if (isActive) {
                accordion.classList.remove('active');
                content.style.maxHeight = "0";
            } else {
                accordion.classList.add('active');
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});


// document.addEventListener("DOMContentLoaded", function() {
//     const accordions = document.querySelectorAll('.expanded_accordion .Accordions__single');

//     accordions.forEach(accordion => {
//         const content = accordion.querySelector('.content');

//         if (window.innerWidth >= 1023) {
//             accordion.classList.add('active');
//             content.style.maxHeight = "98%";
//         }
//     });
// });
